import Nullstack from 'nullstack';
export default function IconServerCog({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-server-cog",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("rect", {
    x: "3",
    y: "4",
    width: "18",
    height: "8",
    rx: "3"
  }), "   ", Nullstack.element("path", {
    d: "M12 20h-6a3 3 0 0 1 -3 -3v-2a3 3 0 0 1 3 -3h10.5"
  }), "   ", Nullstack.element("circle", {
    cx: "18.001",
    cy: "18",
    r: "2"
  }), "   ", Nullstack.element("path", {
    d: "M18.001 14.5v1.5"
  }), "   ", Nullstack.element("path", {
    d: "M18.001 20v1.5"
  }), "   ", Nullstack.element("path", {
    d: "M21.032 16.25l-1.299 .75"
  }), "   ", Nullstack.element("path", {
    d: "M16.27 19l-1.3 .75"
  }), "   ", Nullstack.element("path", {
    d: "M14.97 16.25l1.3 .75"
  }), "   ", Nullstack.element("path", {
    d: "M19.733 19l1.3 .75"
  }), "   ", Nullstack.element("path", {
    d: "M7 8v.01"
  }), "   ", Nullstack.element("path", {
    d: "M7 16v.01"
  }), " ");
}